import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import(/* webpackChunkName: "about" */ '../views/Home.vue')
  },
  {
    path: '/perfil',
    name: 'profile',
    component: () =>
      import(/* webpackChunkName: "about" */ '../views/profile/Profile.vue')
  },
  {
    path: '/password',
    name: 'password',
    component: () =>
      import(/* webpackChunkName: "about" */ '../views/profile/Password.vue')
  },
  {
    path: '/login',
    name: 'login',
    component: () =>
      import(/* webpackChunkName: "system" */ '../views/Login.vue')
  },
  {
    path: '/configuracion',
    name: 'configuration',
    component: () =>
      import(/* webpackChunkName: "configuration" */ '../views/Configuration.vue')
  },
  {
    path: '/ayuda',
    name: 'help',
    component: () =>
      import(/* webpackChunkName: "help" */ '../views/Help.vue')
  },
  {
    path: '/local',
    name: 'local_list',
    component: () =>
      import(/* webpackChunkName: "local" */ '../views/local/LocalList.vue')
  },
  {
    path: '/local/crear',
    name: 'local_create',
    component: () =>
      import(/* webpackChunkName: "local" */ '../views/local/LocalCreate.vue')
  },
  {
    path: '/local/:id/actualizar',
    name: 'local_update',
    component: () =>
      import(/* webpackChunkName: "local" */ '../views/local/LocalUpdate.vue')
  },
  {
    path: '/categorias',
    name: 'category_list',
    component: () =>
      import(
        /* webpackChunkName: "category" */ '../views/category/CategoryList.vue'
      )
  },
  {
    path: '/categorias/crear',
    name: 'category_create',
    component: () =>
      import(
        /* webpackChunkName: "category" */ '../views/category/CategoryCreate.vue'
      )
  },
  {
    path: '/categorias/:id/actualizar',
    name: 'category_update',
    component: () =>
      import(
        /* webpackChunkName: "category" */ '../views/category/CategoryUpdate.vue'
      )
  },
  {
    path: '/productos',
    name: 'product_list',
    component: () =>
      import(
        /* webpackChunkName: "product" */ '../views/product/ProductList.vue'
      )
  },
  {
    path: '/productos/:id/actualizar',
    name: 'product_update',
    component: () =>
      import(
        /* webpackChunkName: "product" */ '../views/product/ProductUpdate.vue'
      )
  },
  {
    path: '/productos/crear',
    name: 'product_create',
    component: () =>
      import(
        /* webpackChunkName: "product" */ '../views/product/ProductCreate.vue'
      )
  },
  {
    path: '/ordenes',
    name: 'order_all_list',
    component: () =>
      import(/* webpackChunkName: "order" */ '../views/orders/OrderAllList.vue')
  },
  {
    path: '/orden/:id',
    name: 'order_detail',
    component: () =>
      import(/* webpackChunkName: "order" */ '../views/orders/OrderDetail.vue')
  },
  {
    path: '/banner',
    name: 'banner_list',
    component: () =>
      import(/* webpackChunkName: "banner" */ '../views/banner/BannerList.vue')
  },
  {
    path: '/banner/:id/actualizar',
    name: 'banner_update',
    component: () =>
      import(
        /* webpackChunkName: "banner" */ '../views/banner/BannerUpdate.vue'
      )
  },
  {
    path: '/banner/crear',
    name: 'banner_create',
    component: () =>
      import(
        /* webpackChunkName: "banner" */ '../views/banner/BannerCreate.vue'
      )
  },
  {
    path: '/factura/:id',
    name: 'factura_detail',
    component: () =>
      import(
        /* webpackChunkName: "factura" */ '../views/factura/FacturaDetail.vue'
      )
  },
  {
    path: '/factura',
    name: 'factura_list',
    component: () =>
      import(
        /* webpackChunkName: "factura" */ '../views/factura/FacturaList.vue'
      )
  },
  {
    path: '/proveedor',
    name: 'supplier_list',
    component: () =>
      import(
        /* webpackChunkName: "supplier" */ '../views/supplier/SupplierList.vue'
      )
  },
  {
    path: '/proveedor/crear',
    name: 'supplier_create',
    component: () =>
      import(
        /* webpackChunkName: "supplier" */ '../views/supplier/SupplierCreate.vue'
      )
  },
  {
    path: '/proveedor/:id/actualizar',
    name: 'supplier_update',
    component: () => import('../views/supplier/SupplierUpdate.vue')
  },
  {
    path: '/cupones',
    name: 'coupon_list',
    component: () => import('../views/coupon/CouponList.vue')
  },
  {
    path: '/cupones/crear',
    name: 'coupon_create',
    component: () => import('../views/coupon/CouponCreate.vue')
  },
  {
    path: '/cupones/:id/actualizar',
    name: 'coupon_update',
    component: () => import('../views/coupon/CouponUpdate.vue')
  },
  {
    path: '/promociones',
    name: 'promotion_list',
    component: () => import('../views/promotion/PromotionList.vue')
  },
  {
    path: '/promociones/crear',
    name: 'promotion_create',
    component: () => import('../views/promotion/PromotionCreate.vue')
  },
  {
    path: '/promociones/:id/actualizar',
    name: 'promotion_update',
    component: () => import('../views/promotion/PromotionUpdate.vue')
  },
  {
    path: '/404',
    component: () =>
      import(/* webpackChunkName: "banner" */ '../views/Error.vue')
  },
  { path: '*', redirect: '/404' }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  if (to.name !== 'login' && !Vue.localStorage.get('token')) {
    next({ name: 'login' })
  } else {
    store.commit('settings/SET_LOADING', true)
    next()
  }
  // if the user is not authenticated, `next` is called twice
})
export default router
